export default class User {
    id_user;
    name;
    role;
    idc;
    token;
    enabled;
}
